import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlObras = '/service/materiais/obras/'

class EmpreiteirasObrasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }

        return this.conex.post(urlObras + 'detalhesEmpreiteiras/', JSON.stringify(data))
    }
}

export default EmpreiteirasObrasService
